import React, { useState } from 'react';
import { Sparkles, RefreshCw } from 'lucide-react';

/**
 * AIUpdateIcon - Small icon button with tooltip for AI-powered data updates
 * Can be placed next to college names in any tab
 */
const AIUpdateIcon = ({
  tooltip = 'Update with AI',
  onClick,
  isLoading = false,
  disabled = false
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        onClick={(e) => {
          e.stopPropagation(); // Prevent card click
          if (!disabled && !isLoading && onClick) {
            onClick();
          }
        }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        disabled={disabled || isLoading}
        className="p-1 rounded-lg hover:bg-teal-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed group"
        aria-label={tooltip}
      >
        {isLoading ? (
          <RefreshCw className="w-4 h-4 text-teal-600 animate-spin" />
        ) : (
          <Sparkles className="w-4 h-4 text-teal-600 group-hover:text-teal-700" />
        )}
      </button>

      {/* Tooltip */}
      {showTooltip && !isLoading && (
        <div className="absolute left-1/2 -translate-x-1/2 top-full mt-1 z-50 whitespace-nowrap">
          <div className="bg-slate-900 text-white text-xs px-3 py-1.5 rounded-lg shadow-lg">
            {tooltip}
            <div className="absolute left-1/2 -translate-x-1/2 -top-1 w-2 h-2 bg-slate-900 rotate-45" />
          </div>
        </div>
      )}
    </div>
  );
};

export default AIUpdateIcon;
